module.exports = __webpack_public_path__ + "static/media/icono_comercioexterior.60322d94.png";